import { z } from "zod";
import { httpUrl } from "./url.js";

export const createLeadConfigSchema = z.object({
  provider_name: z.string().min(1, "Provider name is required").max(255),
  provider_type: z.string().min(1, "Provider type is required").max(100),
  client_id: z.string().max(255).nullable().optional(),      // 090: nullable for internal-link ads
  api_base_url: httpUrl(500).nullable().optional(),
  api_key: z.string().max(500).nullable().optional(),
  logo_url: httpUrl(500).nullable().optional(),
  tagline: z.string().max(500).nullable().optional(),
  cta_label: z.string().min(1, "CTA label is required").max(100).optional(),
  cta_url: httpUrl(500).nullable().optional(),        // 090: when set, carousel renders a plain link button
  is_global: z.boolean().optional(),
  active: z.boolean().optional(),
});

export const updateLeadConfigSchema = z.object({
  provider_name: z.string().min(1).max(255).optional(),
  provider_type: z.string().min(1).max(100).optional(),
  client_id: z.string().max(255).nullable().optional(),
  api_base_url: httpUrl(500).nullable().optional(),
  api_key: z.string().max(500).nullable().optional(),
  logo_url: httpUrl(500).nullable().optional(),
  tagline: z.string().max(500).nullable().optional(),
  cta_label: z.string().min(1).max(100).optional(),
  cta_url: httpUrl(500).nullable().optional(),
  is_global: z.boolean().optional(),
  active: z.boolean().optional(),
});

export const assignLeadSchoolSchema = z.object({
  school_id: z.string().min(1, "School ID is required"),
  placement_slot: z.string().min(1, "Placement slot is required").max(100),
  priority: z.number().int().min(0).optional(),
  active: z.boolean().optional(),
});

export const submitLeadSchema = z.object({
  config_id: z.string().min(1, "Config ID is required"),
  school_id: z.string().optional(),
  first_name: z.string().min(1, "First name is required").max(255),
  surname: z.string().min(1, "Surname is required").max(255),
  mobile: z.string().min(1, "Mobile number is required").max(20),
});

export type CreateLeadConfigInput = z.infer<typeof createLeadConfigSchema>;
export type UpdateLeadConfigInput = z.infer<typeof updateLeadConfigSchema>;
export type AssignLeadSchoolInput = z.infer<typeof assignLeadSchoolSchema>;
export type SubmitLeadInput = z.infer<typeof submitLeadSchema>;
